var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{attrs:{"text":"The date and time are in your local timezone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }